/**
* 语音房管理
*/
<template>
	<div style="display: flex;flex-direction: column; height: 89vh;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<!-- 永久封禁的提示框 需要输入封禁原因 -->
		<el-dialog title="请输入封禁原因" :visible.sync="dialogRejecte">
			<el-input placeholder="请输入原因" v-model="pretestResult">
				<template slot="prepend">原因:</template>
			</el-input>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogRejecte = false">取消</el-button>
				<el-button type="primary" @click="bannedVoiceRoomNext()">确定永久封禁</el-button>
			</div>
		</el-dialog>


		<!-- 查询直播间直播时长，历史收益等信息 -->
		<el-dialog title="直播间信息" :visible.sync="dialogVisible" width="60%">
			<el-descriptions>
				<el-descriptions-item label="总礼物值">{{ roomInfoData.totalGiftValue }}</el-descriptions-item>
				<el-descriptions-item
					label="总直播时长">{{ this.formatTime(roomInfoData.totalLiveTime)  }}</el-descriptions-item>
				<el-descriptions-item label="总访问人数">{{ roomInfoData.totalVisitorsNum }}</el-descriptions-item>
				<el-descriptions-item label="可提现金额">{{ roomInfoData.withdrawAmount }}</el-descriptions-item>
				<el-descriptions-item label="可提现金额">{{ roomInfoData.amountCurrencyCode }}</el-descriptions-item>
			</el-descriptions>

			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">确认</el-button>
			</span>
		</el-dialog>


		<!-- 第一行搜索条件 -->
		<div style="margin: 0 5px; display: flex;">

			<el-form ref="form" label-width="80px">
				<el-form-item label="封房时间">
					<el-date-picker v-model="value" type="daterange" @change="selectTime" start-placeholder="开始日期"
						end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
					</el-date-picker>
				</el-form-item>
			</el-form>

			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="房间状态" style="width: 300px;">
					<el-select v-model="form.activityRegion" clearable placeholder="请选择房间状态" @change="select">
						<!-- 0未开播 1开播中 2永久封禁  3封禁24小时(这个状态是后面加的，所以不支持查询)-->
						<el-option label="未开播" value="0"></el-option>
						<el-option label="开播中" value="1"></el-option>
						<el-option label="永久封禁" value="2"></el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<el-input style="margin-left: 15px; margin-right: 10px; height: 20px;" placeholder="请输入内容" v-model="roomId"
				label-width="60px">
				<template slot="prepend">房间Id</template>
			</el-input>

			<el-input style="margin-left: 15px; margin-right: 10px; height: 20px;" placeholder="请输入内容"
				v-model="roomNum001" label-width="60px">
				<template slot="prepend">房间号</template>
			</el-input>

			<el-button style="margin-left: 5px; height: 40px;" type="primary" icon="el-icon-search"
				@click="search()">搜索</el-button>

		</div>



		<!-- 列表 -->
		<el-table :data="tableData" height="200" stripe border style="width: 100%; flex: 1; overflow: auto;">
			<el-table-column type="index" :index="indexMethod" align="center"></el-table-column>
			<el-table-column label="用户ID" align="center" width="94">
				<template slot-scope="scope">
					<div slot="reference" class="name-wrapper">
						<p style="font-size: 14px;">{{ scope.row.userId }}</p>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="roomId" label="房间Id" align="center" width="89" sortable></el-table-column>
			<el-table-column prop="roomNum" label="房间号" align="center" width="104" sortable></el-table-column>
			<el-table-column prop="noticeMsg" label="公告内容" align="center" width="144"></el-table-column>

			<el-table-column prop="roomBackImg" label="背景图" align="center" width="164"></el-table-column>
			<el-table-column label="封面图" align="center" width="164">
				<template slot-scope="scope">
					<a :href="scope.row.roomFrontImg" target="_blank">
						<img :src="scope.row.roomFrontImg" :alt="scope.row.roomFrontImg"
							style="width: 100px; height: 100px; object-fit: contain;" />
					</a>
				</template>
			</el-table-column>

			<el-table-column prop="bannedTime" label="封禁时间" align="center" width="164"></el-table-column>
			<el-table-column prop="bannedCause" label="封禁原因" align="center" width="124"></el-table-column>
			<el-table-column prop="firstLanguage" label="首选语音" align="center" width="79"></el-table-column>
			<el-table-column prop="secondLanguage" label="次选语音" align="center" width="79"></el-table-column>
			<el-table-column label="开播状态" align="center">
				<template slot-scope="scope">
					<div slot="reference" class="name-wrapper">
						<!-- 0未开播 1开播中 2永久封禁  3封禁24小时(这个状态是后面加的，所以不支持查询) -->
						<p v-show="scope.row.openStatus==0" style="font-size: 14px; color: #0000FF;">未开播</p>
						<p v-show="scope.row.openStatus==1" style="font-size: 14px; color: #008000;">开播中</p>
						<p v-show="scope.row.openStatus==2" style="font-size: 14px; color: #FF0000;">永久封禁</p>
						<p v-show="scope.row.openStatus==3" style="font-size: 14px; color: #008000;">封禁24小时</p>
					</div>
				</template>
			</el-table-column>

			<el-table-column fixed="right" label="操作" width="144" align="center">
				<template slot-scope="scope">
					<el-button @click="inquiryRoomInfo(scope.$index)" type="text" size="small">查询直播间信息</el-button>
					<el-button v-show="scope.row.openStatus!=2" @click="bannedVoiceRoomDialog(scope.$index)" type="text"
						size="small">永久封禁</el-button>
					<el-button v-show="scope.row.openStatus==2" @click="UnbannedVoiceRoom(scope.$index)" type="text"
						size="small">解除永久封禁</el-button>
					<el-button v-show="scope.row.openStatus==3" @click="unLockTempVoiceRoom(scope.$index)" type="text"
						size="small">解除24小时封禁</el-button>
				</template>
			</el-table-column>

		</el-table>

		<!-- 页码 -->
		<div class="block"
			style="flex-shrink: 0; width: 100%; height: 60px; display: flex; align-items: center; justify-content: center;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[20, 30, 40,50,100,200]" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				value: '', //时间
				startTime: 0, //开始时间
				endTime: 0, //结束时间
				roomId: '', //房间Id
				roomNum001: '', //房间号
				form: {
					activityRegion: '', // 根据需要添加其他表单字段
				},
				typeId: 0, //直播间状态
				pageSize: 20, //每页条数
				pageNum: 1, //当前页数
				total: 0, //一共有多少条数据
				tableData: null, //列表数据
				dialogRejecte: false, //拒绝提示框
				pretestResult: '', //拒绝的原因
				bannedVoiceRoomID: '', //永久封禁的Id
				dialogVisible: false, //展示直播间结果的提示框
				roomInfoData: '', //直播间详情数据
				//...
			};
		},
		mounted() {
			this.fetchData(this.pageNum, this.pageSize); //语音房列表
		},
		methods: {
			fetchData(pageNum, pageSize) { //语音房列表
				this.loadingData = true;

				this.pageSize = pageSize;
				this.pageNum = pageNum;

				const requestData = {}; //传递的参数
				requestData.pageSize = pageSize;
				requestData.pageNum = pageNum;


				if (this.startTime > 0) { //开始时间
					requestData.startTime = this.startTime;
				}
				if (this.endTime > 0) { //结束时间
					requestData.endTime = this.endTime;
				}
				if (this.typeId > 0) { //直播间状态
					requestData.openStatus = this.typeId;
				}
				if (this.roomId > 0) { //房间id
					requestData.roomId = this.roomId;
				}

				if (this.roomNum001.length > 0) { //房间号
					console.log("this.roomNum001  0000000")
					requestData.roomNum = this.roomNum001;
				}


				console.log("语音房列表  发送的数据：", requestData)

				axios.post(this.$p_url + '/voiceRoom/H5/getH5VoiceRoomList', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("语音房列表  后台数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "authFailed") { //登录失效
							Cookies.remove("token");
							this.$router.push({ //跳转到登录
								path: '/Login1715',
								query: {}
							});
						}
						if (state === "success") { // 检查状态
							this.total = response.data.data.total; //一共有多少条数据

							for (let i = 0; i < response.data.data.list.length; i++) {
								//身份证正面
								response.data.data.list[i].cardFrontImg = this.$p_urlImage + response.data.data.list[i]
									.cardFrontImg;
								//身份证反面
								response.data.data.list[i].cardBackImg = this.$p_urlImage + response.data.data.list[i]
									.cardBackImg;
								//手持身份证
								response.data.data.list[i].cardHandImg = this.$p_urlImage + response.data.data.list[i]
									.cardHandImg;
								//银行卡照片
								response.data.data.list[i].bankImg = this.$p_urlImage + response.data.data.list[i]
									.bankImg;
							}

							this.tableData = response.data.data.list;
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			inquiryRoomInfo(index) { //查询直播间详情
				this.dialogRejecte = false;
				const requestData = {}; //传递的参数

				this.loadingData = true;
				axios.post(this.$p_url + '/voiceRoom/H5/getH5VoiceRoomAnchorManagerRes/' + this.tableData[index].roomId +
						"/" + this.tableData[index].userId,
						requestData, {
							withCredentials: true,
							headers: {
								'Content-Type': 'application/json',
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
					.then(response => {
						try {
							this.loadingData = false;
							console.log("查询直播间详情 的返回：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.roomInfoData = response.data.data;
								this.dialogVisible = true;
							} else {
								alert("服务器错误:" + response.data.message)
							}
						} catch (error) {
							alert("查询直播间详情 异常: " + error.message);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
						console.error('Error fetching data:', error);
					});
			},
			bannedVoiceRoomDialog(index) { //永久封禁 提示框
				this.dialogRejecte = true;
				this.bannedVoiceRoomID = this.tableData[index].roomId;
			},
			bannedVoiceRoomNext() { //永久封禁
				this.dialogRejecte = false;
				const requestData = {}; //传递的参数
				requestData.bannedCause = this.pretestResult; //封禁原因
				requestData.roomId = this.bannedVoiceRoomID; //房间Id

				console.log('永久封禁 传值', requestData);
				this.loadingData = true;
				axios.post(this.$p_url + '/voiceRoom/H5/bannedVoiceRoom',
						requestData, {
							withCredentials: true,
							headers: {
								'Content-Type': 'application/json',
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
					.then(response => {
						try {
							this.loadingData = false;
							console.log("永久封禁 的返回：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.fetchData(this.pageNum, this.pageSize); //进行刷新
							} else {
								alert("服务器错误:" + response.data.message)
							}
						} catch (error) {
							alert("永久封禁 异常: " + error.message);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
						console.error('Error fetching data:', error);
					});
			},
			UnbannedVoiceRoom(index) { //解除永久封禁
				this.dialogRejecte = false;
				const requestData = {}; //传递的参数
				console.log("解除永久封禁：", this.tableData[index].roomId)

				this.loadingData = true;
				axios.post(this.$p_url + '/voiceRoom/H5/UnbannedVoiceRoom/' + this.tableData[index].roomId, requestData, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						try {
							this.loadingData = false;
							console.log("解除永久封禁 的返回：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.fetchData(this.pageNum, this.pageSize); //进行刷新
							} else {
								alert("服务器错误:" + response.data.message)
							}
						} catch (error) {
							alert("解除永久封禁 异常: " + error.message);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
						console.error('Error fetching data:', error);
					});
			},
			unLockTempVoiceRoom(index) { //解除永久封禁(24小时)
				this.dialogRejecte = false;
				const requestData = {}; //传递的参数
				this.loadingData = true;
				axios.post(this.$p_url + '/voiceRoom/H5/unLockTempVoiceRoom/' + this.tableData[index].roomId,
						requestData, {
							withCredentials: true,
							headers: {
								'Content-Type': 'application/json',
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
					.then(response => {
						try {
							this.loadingData = false;
							console.log("解除永久封禁(24小时) 的返回：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.fetchData(this.pageNum, this.pageSize); //进行刷新
							} else {
								alert("服务器错误:" + response.data.message)
							}
						} catch (error) {
							alert("解除永久封禁(24小时) 异常: " + error.message);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
						console.error('Error fetching data:', error);
					});
			},
			search() { //单击了搜索
				this.fetchData(1, this.pageSize);
			},
			handleSizeChange(val) { //设置每页多少条
				this.pageSize = val;
				this.fetchData(this.pageNum, val);
			},
			handleCurrentChange(val) { //查询第几页的数据
				this.fetchData(val, this.pageSize);
			},
			indexMethod(index) {
				if (this.pageNum == 1) {
					return index + 1;
				} else {
					return (this.pageNum - 1) * this.pageSize + index + 1;
				}

			},
			selectTime() { //选择了时间
				if (this.value == null) {
					this.startTime = 0;
					this.endTime = 0;
					this.fetchData(1, this.pageSize);
				} else {
					[this.startTime, this.endTime] = this.value;
					// 将时间字符串转换为时间戳
					this.startTime = new Date(this.startTime).getTime();
					this.endTime = new Date(this.endTime).getTime();
					this.fetchData(1, this.pageSize);
				}
			},
			select() { //选中了某个值
				this.typeId = this.form.activityRegion;
				this.fetchData(1, this.pageSize);
			},
			formatTime(seconds) { //将秒转换为时间
				const days = Math.floor(seconds / 86400);
				const hours = Math.floor((seconds % 86400) / 3600);
				const minutes = Math.floor((seconds % 3600) / 60);
				const secs = seconds % 60;

				return `${days}天 ${hours}小时 ${minutes}分钟 ${secs}秒`;
			},
			//...
		}
		//...
	}
</script>

<style>
</style>